import React, { useState, useContext } from "react";
import { UserContext } from './context/UserContext';
import requests from "./base";
import swal from "sweetalert";
import PhoneInput from "react-phone-input-2";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const { addUser, setIsLogged } = useContext(UserContext);
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    Email: "",
    Password: "",
    MobileNo: "",
    IDnumber: "",
    CountryID: "1",
    Languageid: "sample string 7"
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await requests.post("vendorlogin", formData);
    
      if (response) {
        if (response.ResponseCode === 1) {
          addUser(response);
          setIsLogged(true);
          swal("Success", response.ResponseMessage, "success");
          if (response.Data.UserType !== 4) {
          navigate("/Admin");
          }
          else{
            navigate("/");
          }
          // console.log("Login successful:", response);
        } else if (response.ResponseCode === 2) {
          swal("Error", response.ResponseMessage || "Your account is pending approval Please Contact Your Admin.", "error");
        
        } 
        else if (response.ResponseMessage === "Invalid Login") {
          swal("Error", "Incorrect password or username", "error");
        
        } 
        else {
          swal("Error", "Unexpected response. Please try again later.", "error");
          console.warn("Unexpected response:", response);
        }
      } else {
        swal("Error", "No response received. Please try again.", "error");
        console.warn("No response from server:", response);
      }
    } catch (error) {
      console.error("Login failed:", error);
      swal("Error", "Login failed. Please try again.", "error");
    }
    
  };

  return (
    <div style={{
      backgroundColor: "#00253d", 
      height: "100vh", 
      display: "flex", 
      justifyContent: "center", 
      alignItems: "center"
    }}>
      <div style={{
        backgroundColor: "white", 
        padding: "40px", 
        borderRadius: "8px", 
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        width: "100%",
        maxWidth: "400px",
      }}> 
       <div className="text-center m-3">
       <img
              src="../acre-africa-full-black-logo.svg"
              alt="User"
              
              style={{ width: "auto", height: "40px", objectFit: "cover" }}
            />
      
       </div>
       <div className="text-center m-3 text-muted fw-bold">
      
        <h5 style={{ textAlign: "center", marginBottom: "20px" }}>Vendor Login</h5>
       </div>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "15px" }}>
            <label>Email</label><br />
            <input
              type="email"
              name="Email"
              value={formData.Email}
              onChange={handleChange}
              required
              placeholder="Enter your email"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc"
              }}
            />
          </div>

          <div style={{ marginBottom: "15px", position: "relative" }}>
  <label>Password</label><br />
  <input
    type={showPassword ? "text" : "password"}
    name="Password"
    value={formData.Password}
    onChange={handleChange}
    required
    placeholder="Enter your password"
    style={{
      width: "100%",
      padding: "10px 40px 10px 10px", // space for icon
      borderRadius: "5px",
      border: "1px solid #ccc"
    }}
  />
  
  {/* Toggle Icon */}
  <span
    className={`mdi ${showPassword ? "mdi mdi-eye-off-outline" : "mdi mdi-eye-outline"}`}
    onClick={() => setShowPassword(!showPassword)}
    style={{
      position: "absolute",
      right: "10px",
      top: "37px",
      cursor: "pointer",
      fontSize: "20px",
      color: "#555"
    }}
  ></span>
</div>

          <div style={{ gridColumn: "span 1", marginTop: "5px" }}>
                  <label>
                    Phone Number <span style={{ color: "red" }}> *</span>
                  </label>{" "}
                  <br />
                  <PhoneInput
                    country={"ke"}
                    onlyCountries={["ke"]}
                    value={formData.MobileNo}
                    onChange={(phone) => {
                      const last9 = phone.slice(-9);
                      const formatted = "+" + phone.replace(/[^0-9]/g, "");
                      setFormData((prev) => ({
                        ...prev,
                        MobileNo: formatted,
                        Last9Digits: last9,
                      }));
                    }}
                    inputProps={{
                      name: "MobileNo",
                      required: true,
                      maxLength: 16,
                    }}
                    enableSearch
                    countryCodeEditable={false}
                    inputStyle={{
                      // or '300px', '50%' etc.
                      height: "50px",
                    }}
                  />
                 
                </div>
          <div style={{ marginBottom: "15px" }}>
            <label>ID Number</label><br />
            <input
              type="text"
              name="IDnumber"
              value={formData.IDnumber}
              onChange={handleChange}
              required
              placeholder="Enter your ID number"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "5px",
                border: "1px solid #ccc"
              }}
            />
          </div>

          <button 
            type="submit" 
            style={{
              width: "100%", 
              padding: "10px", 
              backgroundColor: "#00253d", 
              color: "#fff", 
              borderRadius: "5px", 
              border: "none", 
              cursor: "pointer", 

            }}
          >
            LOGIN <small> <span class="mdi mdi-greater-than mx-auto"></span></small>


          </button>
          
        </form>
        <small className="m-3"> Dont have an account yet?<a href="/RegisterVendor" style={{ color: "#f5821f" }}>Register </a></small>
      </div>
    </div>
  );
};

export default Login;
